import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Card from "../../components/Card";
import "./product.css";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const location = useLocation();

  // Get query parameter (?q=)
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("q") || "";

  // Fetch products from NEW API format
  const fetchProducts = async (brand = "", query = "") => {
    const url =
      process.env.REACT_APP_BASE_URL +
      `/api/products/getproducts${brand || query ? `?${brand ? `brand=${brand}` : `q=${query}`}` : ""
      }`;

    const response = await fetch(url);
    const data = await response.json();

    const cleaned = data
      .map(item => ({
        id: item._id,
        sku: item.sku,
        brand: item.Brand,
        description: item.Description,
        image: item.ProductimageURL,
        Category: item.Category,
        price: item.finalPrice || "",

      }));


    setProducts(cleaned);
    calculateBrands(cleaned);
  };

  // Extract brand list from products
  const calculateBrands = (products) => {
    const brandCounts = products.reduce((acc, p) => {
      if (!p.brand) return acc;
      acc[p.brand] = (acc[p.brand] || 0) + 1;
      return acc;
    }, {});

    const brandList = Object.entries(brandCounts).map(([brand, count]) => ({
      brand,
      count,
    }));

    setBrands(brandList);
  };

  // Fetch when query changes
  useEffect(() => {
    fetchProducts("", query);
  }, [query]);

  const handleBrandChange = (brand) => {
    setSelectedBrand(brand);
    fetchProducts(brand, query);
  };

  return (
    <div className="canvas mt-5">
      <div className="row gap-y-3">

        {/* SIDEBAR FILTERS */}
        <div className="col-md-3">
          <h3 className="mb-3">Filter by Brand</h3>
          <ul className="list-group brandfilter">
            {brands.map(({ brand, count }) => (
              <li
                key={brand}
                className={`list-group-item ${selectedBrand === brand ? "active" : ""
                  }`}
                onClick={() => handleBrandChange(brand)}
                style={{ cursor: "pointer" }}
              >
                {brand} <span className="badge float-end">{count}</span>
              </li>
            ))}

            {/* ALL BRANDS */}
            <li
              className={`list-group-item ${selectedBrand === "" ? "active" : ""
                }`}
              onClick={() => handleBrandChange("")}
              style={{ cursor: "pointer" }}
            >
              All <span className="badge bg-secondary float-end">{products.length}</span>
            </li>
          </ul>
        </div>

        {/* PRODUCTS GRID */}
        <div className="col-md-9 mt-md-0 mt-3">
          <div className="d-flex gap-3 flex-wrap align-items-center justify-content-center justify-content-md-start">
            {products.map((product) => (
              <div style={{ width: "300px" }} className="my-1">
                <Card
                  product={product}
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Products;
